/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * InfinityLearn Doubts API
 * API for managing doubts, solutions, user feedback, and related functionalities.
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptSolutionRequest,
  AinaFreeDoubtResponse,
  AutosolveRequest,
  AutosolveResponse,
  AvailableFreeDoubtsResponse,
  BookmarkBody,
  ConnectotutorRequest,
  ConnecttotutorResponse,
  CreateDoubtRespone,
  DRSRagRequestBody,
  DRSResponseBodyNew,
  DoubtResponse,
  DoubtsNewQbRequestModel,
  DoubtsQbResponseModel,
  DoubtsSuggestResponse,
  DoubtstoBeDeductedResponse,
  DreFeedbackReponse,
  DreFeedbackRequest,
  DrsRequestBody,
  EndSessionRequestBody,
  FeedBackPromptResponse,
  FeedbackRequest,
  FilterDoubt,
  GetAutomatedMessagesResponse,
  GetDc1AvailableFreeDoubtsFromSourceParams,
  GetDc1AvailableFreeDoubtsParams,
  GetDc1GetGeneratedSolutionParams,
  GetDc1UsersUseridBookmarksv2Params,
  GetDc1UsersUseridDoubtsParams,
  GetDoubtsCoinRedemptionResponse,
  GetDoubtsSolutionsResponse,
  GetFbDoubtstoBeDeductedParams,
  GetRagvSolutionResponse,
  GetRedeemcoinsResponse,
  GetTotalCoinsEarnedByUserIdResponse,
  ImageOCRresponse,
  MyQuestionResponse,
  OtpResponse,
  PostDc1DoubtBody,
  PostDc1GetDoubtsCoinRedemptionParams,
  PostDc1QuestionsImageocrBody,
  PostDc1UploadImageBody,
  PostDc1V2CreateDoubtBody,
  PostDrsQuestionsParams,
  PostImage,
  PutDc1DoubtDoubtId200,
  PutDc1DoubtDoubtIdBody,
  RAGNewRequest,
  RAGResponseBody,
  RAGVResponse,
  RatingRequest,
  SaveRedeemSummaryRequest,
  SaveRedeemSummaryResponse,
  StandardResponse,
  StoreFeedBackResponse,
  StoreFeedbackRequest,
  SubmitSolutionsFeedbackRequest,
  SuggestBook,
  Suggestion,
  TagsResponse,
  TruecallerLoginRequestModel,
  UploadImageResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authenticates a user via Truecaller.
 * @summary Truecaller Login
 */
export const postApiAuthenticationLogin = (
  truecallerLoginRequestModel: TruecallerLoginRequestModel,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OtpResponse>(
    {
      url: `/api/authentication/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: truecallerLoginRequestModel,
      signal,
    },
    options,
  );
};

export const getPostApiAuthenticationLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthenticationLogin>>,
    TError,
    { data: TruecallerLoginRequestModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthenticationLogin>>,
  TError,
  { data: TruecallerLoginRequestModel },
  TContext
> => {
  const mutationKey = ["postApiAuthenticationLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAuthenticationLogin>>,
    { data: TruecallerLoginRequestModel }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAuthenticationLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthenticationLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiAuthenticationLogin>>
>;
export type PostApiAuthenticationLoginMutationBody =
  TruecallerLoginRequestModel;
export type PostApiAuthenticationLoginMutationError = unknown;

/**
 * @summary Truecaller Login
 */
export const usePostApiAuthenticationLogin = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuthenticationLogin>>,
      TError,
      { data: TruecallerLoginRequestModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthenticationLogin>>,
  TError,
  { data: TruecallerLoginRequestModel },
  TContext
> => {
  const mutationOptions = getPostApiAuthenticationLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload OCR Image (v1)
 */
export const postDc1QuestionsImageOCR = (
  postDc1QuestionsImageocrBody: PostDc1QuestionsImageocrBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (postDc1QuestionsImageocrBody.file !== undefined) {
    formData.append(`file`, postDc1QuestionsImageocrBody.file);
  }

  return customInstance<PostImage>(
    {
      url: `/dc/1/questions/imageOCR`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPostDc1QuestionsImageOCRMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
    TError,
    { data: PostDc1QuestionsImageocrBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageocrBody },
  TContext
> => {
  const mutationKey = ["postDc1QuestionsImageOCR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
    { data: PostDc1QuestionsImageocrBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1QuestionsImageOCR(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1QuestionsImageOCRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>
>;
export type PostDc1QuestionsImageOCRMutationBody = PostDc1QuestionsImageocrBody;
export type PostDc1QuestionsImageOCRMutationError = unknown;

/**
 * @summary Upload OCR Image (v1)
 */
export const usePostDc1QuestionsImageOCR = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
      TError,
      { data: PostDc1QuestionsImageocrBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageocrBody },
  TContext
> => {
  const mutationOptions = getPostDc1QuestionsImageOCRMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload OCR Image (v2)
 */
export const postDc1V2ImageOCR = (
  postDc1QuestionsImageocrBody: PostDc1QuestionsImageocrBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (postDc1QuestionsImageocrBody.file !== undefined) {
    formData.append(`file`, postDc1QuestionsImageocrBody.file);
  }

  return customInstance<ImageOCRresponse>(
    {
      url: `/dc/1/v2/ImageOCR`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPostDc1V2ImageOCRMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1V2ImageOCR>>,
    TError,
    { data: PostDc1QuestionsImageocrBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1V2ImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageocrBody },
  TContext
> => {
  const mutationKey = ["postDc1V2ImageOCR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1V2ImageOCR>>,
    { data: PostDc1QuestionsImageocrBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1V2ImageOCR(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1V2ImageOCRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1V2ImageOCR>>
>;
export type PostDc1V2ImageOCRMutationBody = PostDc1QuestionsImageocrBody;
export type PostDc1V2ImageOCRMutationError = unknown;

/**
 * @summary Upload OCR Image (v2)
 */
export const usePostDc1V2ImageOCR = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1V2ImageOCR>>,
      TError,
      { data: PostDc1QuestionsImageocrBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1V2ImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageocrBody },
  TContext
> => {
  const mutationOptions = getPostDc1V2ImageOCRMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new doubt. This path is overloaded in the code for different request bodies.
 * @summary Post a new doubt
 */
export const postDc1Doubt = (
  postDc1DoubtBody: PostDc1DoubtBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DoubtResponse>(
    {
      url: `/dc/1/doubt`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postDc1DoubtBody,
      signal,
    },
    options,
  );
};

export const getPostDc1DoubtMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1Doubt>>,
    TError,
    { data: PostDc1DoubtBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1Doubt>>,
  TError,
  { data: PostDc1DoubtBody },
  TContext
> => {
  const mutationKey = ["postDc1Doubt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1Doubt>>,
    { data: PostDc1DoubtBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1Doubt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1DoubtMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1Doubt>>
>;
export type PostDc1DoubtMutationBody = PostDc1DoubtBody;
export type PostDc1DoubtMutationError = unknown;

/**
 * @summary Post a new doubt
 */
export const usePostDc1Doubt = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1Doubt>>,
      TError,
      { data: PostDc1DoubtBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1Doubt>>,
  TError,
  { data: PostDc1DoubtBody },
  TContext
> => {
  const mutationOptions = getPostDc1DoubtMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get User's Doubts List
 */
export const getDc1UsersUseridDoubts = (
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MyQuestionResponse>(
    { url: `/dc/1/users/${userid}/doubts`, method: "GET", params, signal },
    options,
  );
};

export const getGetDc1UsersUseridDoubtsQueryKey = (
  userid?: number,
  params?: GetDc1UsersUseridDoubtsParams,
) => {
  return [`/dc/1/users/${userid}/doubts`, ...(params ? [params] : [])] as const;
};

export const getGetDc1UsersUseridDoubtsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDc1UsersUseridDoubtsQueryKey(userid, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>
  > = ({ signal }) =>
    getDc1UsersUseridDoubts(userid, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1UsersUseridDoubtsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>
>;
export type GetDc1UsersUseridDoubtsQueryError = unknown;

export function useGetDc1UsersUseridDoubts<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
          TError,
          Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1UsersUseridDoubts<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
          TError,
          Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1UsersUseridDoubts<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User's Doubts List
 */

export function useGetDc1UsersUseridDoubts<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1UsersUseridDoubtsQueryOptions(
    userid,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Doubt Suggestions
 */
export const postDc1DoubtsSuggest = (
  suggestion: Suggestion,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DoubtsSuggestResponse>(
    {
      url: `/dc/1/doubts/suggest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: suggestion,
      signal,
    },
    options,
  );
};

export const getPostDc1DoubtsSuggestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1DoubtsSuggest>>,
    TError,
    { data: Suggestion },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1DoubtsSuggest>>,
  TError,
  { data: Suggestion },
  TContext
> => {
  const mutationKey = ["postDc1DoubtsSuggest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1DoubtsSuggest>>,
    { data: Suggestion }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1DoubtsSuggest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1DoubtsSuggestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1DoubtsSuggest>>
>;
export type PostDc1DoubtsSuggestMutationBody = Suggestion;
export type PostDc1DoubtsSuggestMutationError = unknown;

/**
 * @summary Get Doubt Suggestions
 */
export const usePostDc1DoubtsSuggest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1DoubtsSuggest>>,
      TError,
      { data: Suggestion },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1DoubtsSuggest>>,
  TError,
  { data: Suggestion },
  TContext
> => {
  const mutationOptions = getPostDc1DoubtsSuggestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubt Solutions
 */
export const getDc1DoubtDoubtIdSolutions = (
  doubtId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetDoubtsSolutionsResponse>(
    { url: `/dc/1/doubt/${doubtId}/solutions`, method: "GET", signal },
    options,
  );
};

export const getGetDc1DoubtDoubtIdSolutionsQueryKey = (doubtId?: number) => {
  return [`/dc/1/doubt/${doubtId}/solutions`] as const;
};

export const getGetDc1DoubtDoubtIdSolutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
  TError = unknown,
>(
  doubtId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDc1DoubtDoubtIdSolutionsQueryKey(doubtId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>
  > = ({ signal }) =>
    getDc1DoubtDoubtIdSolutions(doubtId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!doubtId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1DoubtDoubtIdSolutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>
>;
export type GetDc1DoubtDoubtIdSolutionsQueryError = unknown;

export function useGetDc1DoubtDoubtIdSolutions<
  TData = Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
  TError = unknown,
>(
  doubtId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
          TError,
          Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1DoubtDoubtIdSolutions<
  TData = Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
  TError = unknown,
>(
  doubtId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
          TError,
          Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1DoubtDoubtIdSolutions<
  TData = Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
  TError = unknown,
>(
  doubtId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Doubt Solutions
 */

export function useGetDc1DoubtDoubtIdSolutions<
  TData = Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
  TError = unknown,
>(
  doubtId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1DoubtDoubtIdSolutions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1DoubtDoubtIdSolutionsQueryOptions(
    doubtId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit Solution Feedback
 */
export const postDc1SubmitSolutionFeedback = (
  submitSolutionsFeedbackRequest: SubmitSolutionsFeedbackRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/submitSolutionFeedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitSolutionsFeedbackRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1SubmitSolutionFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>,
    TError,
    { data: SubmitSolutionsFeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>,
  TError,
  { data: SubmitSolutionsFeedbackRequest },
  TContext
> => {
  const mutationKey = ["postDc1SubmitSolutionFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>,
    { data: SubmitSolutionsFeedbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1SubmitSolutionFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1SubmitSolutionFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>
>;
export type PostDc1SubmitSolutionFeedbackMutationBody =
  SubmitSolutionsFeedbackRequest;
export type PostDc1SubmitSolutionFeedbackMutationError = unknown;

/**
 * @summary Submit Solution Feedback
 */
export const usePostDc1SubmitSolutionFeedback = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>,
      TError,
      { data: SubmitSolutionsFeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1SubmitSolutionFeedback>>,
  TError,
  { data: SubmitSolutionsFeedbackRequest },
  TContext
> => {
  const mutationOptions =
    getPostDc1SubmitSolutionFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add a Bookmark
 */
export const postDc1DoubtBookmark = (
  bookmarkBody: BookmarkBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/doubt/bookmark`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bookmarkBody,
      signal,
    },
    options,
  );
};

export const getPostDc1DoubtBookmarkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1DoubtBookmark>>,
    TError,
    { data: BookmarkBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1DoubtBookmark>>,
  TError,
  { data: BookmarkBody },
  TContext
> => {
  const mutationKey = ["postDc1DoubtBookmark"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1DoubtBookmark>>,
    { data: BookmarkBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1DoubtBookmark(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1DoubtBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1DoubtBookmark>>
>;
export type PostDc1DoubtBookmarkMutationBody = BookmarkBody;
export type PostDc1DoubtBookmarkMutationError = unknown;

/**
 * @summary Add a Bookmark
 */
export const usePostDc1DoubtBookmark = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1DoubtBookmark>>,
      TError,
      { data: BookmarkBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1DoubtBookmark>>,
  TError,
  { data: BookmarkBody },
  TContext
> => {
  const mutationOptions = getPostDc1DoubtBookmarkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a Bookmark
 */
export const deleteDc1DoubtBookmark = (
  bookmarkBody: BookmarkBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/doubt/bookmark`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: bookmarkBody,
    },
    options,
  );
};

export const getDeleteDc1DoubtBookmarkMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>,
    TError,
    { data: BookmarkBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>,
  TError,
  { data: BookmarkBody },
  TContext
> => {
  const mutationKey = ["deleteDc1DoubtBookmark"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>,
    { data: BookmarkBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteDc1DoubtBookmark(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDc1DoubtBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>
>;
export type DeleteDc1DoubtBookmarkMutationBody = BookmarkBody;
export type DeleteDc1DoubtBookmarkMutationError = unknown;

/**
 * @summary Delete a Bookmark
 */
export const useDeleteDc1DoubtBookmark = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>,
      TError,
      { data: BookmarkBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDc1DoubtBookmark>>,
  TError,
  { data: BookmarkBody },
  TContext
> => {
  const mutationOptions = getDeleteDc1DoubtBookmarkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Bookmarks List (v2)
 */
export const getDc1UsersUseridBookmarksv2 = (
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MyQuestionResponse>(
    { url: `/dc/1/users/${userid}/bookmarksv2`, method: "GET", params, signal },
    options,
  );
};

export const getGetDc1UsersUseridBookmarksv2QueryKey = (
  userid?: number,
  params?: GetDc1UsersUseridBookmarksv2Params,
) => {
  return [
    `/dc/1/users/${userid}/bookmarksv2`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDc1UsersUseridBookmarksv2QueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDc1UsersUseridBookmarksv2QueryKey(userid, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>
  > = ({ signal }) =>
    getDc1UsersUseridBookmarksv2(userid, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1UsersUseridBookmarksv2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>
>;
export type GetDc1UsersUseridBookmarksv2QueryError = unknown;

export function useGetDc1UsersUseridBookmarksv2<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
          TError,
          Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1UsersUseridBookmarksv2<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
          TError,
          Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1UsersUseridBookmarksv2<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bookmarks List (v2)
 */

export function useGetDc1UsersUseridBookmarksv2<
  TData = Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
  TError = unknown,
>(
  userid: number,
  params: GetDc1UsersUseridBookmarksv2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1UsersUseridBookmarksv2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1UsersUseridBookmarksv2QueryOptions(
    userid,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get My Doubts List with Filters (v2)
 */
export const postDc1UserGetDoubtsv2 = (
  filterDoubt: FilterDoubt,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MyQuestionResponse>(
    {
      url: `/dc/1/user/getDoubtsv2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: filterDoubt,
      signal,
    },
    options,
  );
};

export const getPostDc1UserGetDoubtsv2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
    TError,
    { data: FilterDoubt },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
  TError,
  { data: FilterDoubt },
  TContext
> => {
  const mutationKey = ["postDc1UserGetDoubtsv2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
    { data: FilterDoubt }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1UserGetDoubtsv2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1UserGetDoubtsv2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>
>;
export type PostDc1UserGetDoubtsv2MutationBody = FilterDoubt;
export type PostDc1UserGetDoubtsv2MutationError = unknown;

/**
 * @summary Get My Doubts List with Filters (v2)
 */
export const usePostDc1UserGetDoubtsv2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
      TError,
      { data: FilterDoubt },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
  TError,
  { data: FilterDoubt },
  TContext
> => {
  const mutationOptions = getPostDc1UserGetDoubtsv2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit App Feedback
 */
export const postDc1AppFeedback = (
  feedbackRequest: FeedbackRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/app_feedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: feedbackRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1AppFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1AppFeedback>>,
    TError,
    { data: FeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1AppFeedback>>,
  TError,
  { data: FeedbackRequest },
  TContext
> => {
  const mutationKey = ["postDc1AppFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1AppFeedback>>,
    { data: FeedbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1AppFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1AppFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1AppFeedback>>
>;
export type PostDc1AppFeedbackMutationBody = FeedbackRequest;
export type PostDc1AppFeedbackMutationError = unknown;

/**
 * @summary Submit App Feedback
 */
export const usePostDc1AppFeedback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1AppFeedback>>,
      TError,
      { data: FeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1AppFeedback>>,
  TError,
  { data: FeedbackRequest },
  TContext
> => {
  const mutationOptions = getPostDc1AppFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Feedback Tags
 */
export const getDc1FeedbackTags = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TagsResponse>(
    { url: `/dc/1/feedback/tags`, method: "GET", signal },
    options,
  );
};

export const getGetDc1FeedbackTagsQueryKey = () => {
  return [`/dc/1/feedback/tags`] as const;
};

export const getGetDc1FeedbackTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1FeedbackTags>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDc1FeedbackTags>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDc1FeedbackTagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1FeedbackTags>>
  > = ({ signal }) => getDc1FeedbackTags(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1FeedbackTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1FeedbackTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1FeedbackTags>>
>;
export type GetDc1FeedbackTagsQueryError = unknown;

export function useGetDc1FeedbackTags<
  TData = Awaited<ReturnType<typeof getDc1FeedbackTags>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1FeedbackTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1FeedbackTags>>,
          TError,
          Awaited<ReturnType<typeof getDc1FeedbackTags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1FeedbackTags<
  TData = Awaited<ReturnType<typeof getDc1FeedbackTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1FeedbackTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1FeedbackTags>>,
          TError,
          Awaited<ReturnType<typeof getDc1FeedbackTags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1FeedbackTags<
  TData = Awaited<ReturnType<typeof getDc1FeedbackTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1FeedbackTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Feedback Tags
 */

export function useGetDc1FeedbackTags<
  TData = Awaited<ReturnType<typeof getDc1FeedbackTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1FeedbackTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1FeedbackTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Suggest a Book
 */
export const postDc1SuggestionsBooks = (
  suggestBook: SuggestBook,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/suggestions/books`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: suggestBook,
      signal,
    },
    options,
  );
};

export const getPostDc1SuggestionsBooksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1SuggestionsBooks>>,
    TError,
    { data: SuggestBook },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1SuggestionsBooks>>,
  TError,
  { data: SuggestBook },
  TContext
> => {
  const mutationKey = ["postDc1SuggestionsBooks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1SuggestionsBooks>>,
    { data: SuggestBook }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1SuggestionsBooks(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1SuggestionsBooksMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1SuggestionsBooks>>
>;
export type PostDc1SuggestionsBooksMutationBody = SuggestBook;
export type PostDc1SuggestionsBooksMutationError = unknown;

/**
 * @summary Suggest a Book
 */
export const usePostDc1SuggestionsBooks = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1SuggestionsBooks>>,
      TError,
      { data: SuggestBook },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1SuggestionsBooks>>,
  TError,
  { data: SuggestBook },
  TContext
> => {
  const mutationOptions = getPostDc1SuggestionsBooksMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * This path is overloaded. It can update a doubt or edit a doubt with different request bodies.
 * @summary Update or Edit a Doubt
 */
export const putDc1DoubtDoubtId = (
  doubtId: number,
  putDc1DoubtDoubtIdBody: PutDc1DoubtDoubtIdBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<PutDc1DoubtDoubtId200>(
    {
      url: `/dc/1/doubt/${doubtId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: putDc1DoubtDoubtIdBody,
    },
    options,
  );
};

export const getPutDc1DoubtDoubtIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDc1DoubtDoubtId>>,
    TError,
    { doubtId: number; data: PutDc1DoubtDoubtIdBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDc1DoubtDoubtId>>,
  TError,
  { doubtId: number; data: PutDc1DoubtDoubtIdBody },
  TContext
> => {
  const mutationKey = ["putDc1DoubtDoubtId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDc1DoubtDoubtId>>,
    { doubtId: number; data: PutDc1DoubtDoubtIdBody }
  > = (props) => {
    const { doubtId, data } = props ?? {};

    return putDc1DoubtDoubtId(doubtId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDc1DoubtDoubtIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDc1DoubtDoubtId>>
>;
export type PutDc1DoubtDoubtIdMutationBody = PutDc1DoubtDoubtIdBody;
export type PutDc1DoubtDoubtIdMutationError = unknown;

/**
 * @summary Update or Edit a Doubt
 */
export const usePutDc1DoubtDoubtId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDc1DoubtDoubtId>>,
      TError,
      { doubtId: number; data: PutDc1DoubtDoubtIdBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDc1DoubtDoubtId>>,
  TError,
  { doubtId: number; data: PutDc1DoubtDoubtIdBody },
  TContext
> => {
  const mutationOptions = getPutDc1DoubtDoubtIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload Image
 */
export const postDc1UploadImage = (
  postDc1UploadImageBody: PostDc1UploadImageBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (postDc1UploadImageBody.filePart !== undefined) {
    formData.append(`filePart`, postDc1UploadImageBody.filePart);
  }

  return customInstance<UploadImageResponse>(
    {
      url: `/dc/1/upload_image`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPostDc1UploadImageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1UploadImage>>,
    TError,
    { data: PostDc1UploadImageBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1UploadImage>>,
  TError,
  { data: PostDc1UploadImageBody },
  TContext
> => {
  const mutationKey = ["postDc1UploadImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1UploadImage>>,
    { data: PostDc1UploadImageBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1UploadImage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1UploadImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1UploadImage>>
>;
export type PostDc1UploadImageMutationBody = PostDc1UploadImageBody;
export type PostDc1UploadImageMutationError = unknown;

/**
 * @summary Upload Image
 */
export const usePostDc1UploadImage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1UploadImage>>,
      TError,
      { data: PostDc1UploadImageBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1UploadImage>>,
  TError,
  { data: PostDc1UploadImageBody },
  TContext
> => {
  const mutationOptions = getPostDc1UploadImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Accept a Solution
 */
export const postDc1Acceptsolution = (
  acceptSolutionRequest: AcceptSolutionRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/acceptsolution`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: acceptSolutionRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1AcceptsolutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1Acceptsolution>>,
    TError,
    { data: AcceptSolutionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1Acceptsolution>>,
  TError,
  { data: AcceptSolutionRequest },
  TContext
> => {
  const mutationKey = ["postDc1Acceptsolution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1Acceptsolution>>,
    { data: AcceptSolutionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1Acceptsolution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1AcceptsolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1Acceptsolution>>
>;
export type PostDc1AcceptsolutionMutationBody = AcceptSolutionRequest;
export type PostDc1AcceptsolutionMutationError = unknown;

/**
 * @summary Accept a Solution
 */
export const usePostDc1Acceptsolution = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1Acceptsolution>>,
      TError,
      { data: AcceptSolutionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1Acceptsolution>>,
  TError,
  { data: AcceptSolutionRequest },
  TContext
> => {
  const mutationOptions = getPostDc1AcceptsolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit Chat Session Feedback/Rating
 */
export const postDc1SubmitChatSessionFeedback = (
  ratingRequest: RatingRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/submitChatSessionFeedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: ratingRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1SubmitChatSessionFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>,
    TError,
    { data: RatingRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>,
  TError,
  { data: RatingRequest },
  TContext
> => {
  const mutationKey = ["postDc1SubmitChatSessionFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>,
    { data: RatingRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1SubmitChatSessionFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1SubmitChatSessionFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>
>;
export type PostDc1SubmitChatSessionFeedbackMutationBody = RatingRequest;
export type PostDc1SubmitChatSessionFeedbackMutationError = unknown;

/**
 * @summary Submit Chat Session Feedback/Rating
 */
export const usePostDc1SubmitChatSessionFeedback = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>,
      TError,
      { data: RatingRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1SubmitChatSessionFeedback>>,
  TError,
  { data: RatingRequest },
  TContext
> => {
  const mutationOptions =
    getPostDc1SubmitChatSessionFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Check Available Free Doubts
 */
export const getDc1AvailableFreeDoubts = (
  params: GetDc1AvailableFreeDoubtsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AvailableFreeDoubtsResponse>(
    { url: `/dc/1/availableFreeDoubts`, method: "GET", params, signal },
    options,
  );
};

export const getGetDc1AvailableFreeDoubtsQueryKey = (
  params?: GetDc1AvailableFreeDoubtsParams,
) => {
  return [`/dc/1/availableFreeDoubts`, ...(params ? [params] : [])] as const;
};

export const getGetDc1AvailableFreeDoubtsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDc1AvailableFreeDoubtsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>
  > = ({ signal }) => getDc1AvailableFreeDoubts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1AvailableFreeDoubtsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>
>;
export type GetDc1AvailableFreeDoubtsQueryError = unknown;

export function useGetDc1AvailableFreeDoubts<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
          TError,
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1AvailableFreeDoubts<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
          TError,
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1AvailableFreeDoubts<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Available Free Doubts
 */

export function useGetDc1AvailableFreeDoubts<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1AvailableFreeDoubtsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Check Available Aina Free Doubts from Source
 */
export const getDc1AvailableFreeDoubtsFromSource = (
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AinaFreeDoubtResponse>(
    {
      url: `/dc/1/availableFreeDoubtsFromSource`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetDc1AvailableFreeDoubtsFromSourceQueryKey = (
  params?: GetDc1AvailableFreeDoubtsFromSourceParams,
) => {
  return [
    `/dc/1/availableFreeDoubtsFromSource`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDc1AvailableFreeDoubtsFromSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDc1AvailableFreeDoubtsFromSourceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>
  > = ({ signal }) =>
    getDc1AvailableFreeDoubtsFromSource(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1AvailableFreeDoubtsFromSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>
>;
export type GetDc1AvailableFreeDoubtsFromSourceQueryError = unknown;

export function useGetDc1AvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
          TError,
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1AvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
          TError,
          Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1AvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Available Aina Free Doubts from Source
 */

export function useGetDc1AvailableFreeDoubtsFromSource<
  TData = Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
  TError = unknown,
>(
  params: GetDc1AvailableFreeDoubtsFromSourceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1AvailableFreeDoubtsFromSource>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1AvailableFreeDoubtsFromSourceQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary End Chat Session
 */
export const postDc1EndChatSession = (
  endSessionRequestBody: EndSessionRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/endChatSession`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: endSessionRequestBody,
      signal,
    },
    options,
  );
};

export const getPostDc1EndChatSessionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1EndChatSession>>,
    TError,
    { data: EndSessionRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1EndChatSession>>,
  TError,
  { data: EndSessionRequestBody },
  TContext
> => {
  const mutationKey = ["postDc1EndChatSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1EndChatSession>>,
    { data: EndSessionRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1EndChatSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1EndChatSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1EndChatSession>>
>;
export type PostDc1EndChatSessionMutationBody = EndSessionRequestBody;
export type PostDc1EndChatSessionMutationError = unknown;

/**
 * @summary End Chat Session
 */
export const usePostDc1EndChatSession = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1EndChatSession>>,
      TError,
      { data: EndSessionRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1EndChatSession>>,
  TError,
  { data: EndSessionRequestBody },
  TContext
> => {
  const mutationOptions = getPostDc1EndChatSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Handover to Expert
 */
export const postDc1HandoverToExpert = (
  endSessionRequestBody: EndSessionRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StandardResponse>(
    {
      url: `/dc/1/handoverToExpert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: endSessionRequestBody,
      signal,
    },
    options,
  );
};

export const getPostDc1HandoverToExpertMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1HandoverToExpert>>,
    TError,
    { data: EndSessionRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1HandoverToExpert>>,
  TError,
  { data: EndSessionRequestBody },
  TContext
> => {
  const mutationKey = ["postDc1HandoverToExpert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1HandoverToExpert>>,
    { data: EndSessionRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1HandoverToExpert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1HandoverToExpertMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1HandoverToExpert>>
>;
export type PostDc1HandoverToExpertMutationBody = EndSessionRequestBody;
export type PostDc1HandoverToExpertMutationError = unknown;

/**
 * @summary Handover to Expert
 */
export const usePostDc1HandoverToExpert = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1HandoverToExpert>>,
      TError,
      { data: EndSessionRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1HandoverToExpert>>,
  TError,
  { data: EndSessionRequestBody },
  TContext
> => {
  const mutationOptions = getPostDc1HandoverToExpertMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Automated Messages
 */
export const getDc1GetAutomatedMessages = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetAutomatedMessagesResponse>(
    { url: `/dc/1/getAutomatedMessages`, method: "GET", signal },
    options,
  );
};

export const getGetDc1GetAutomatedMessagesQueryKey = () => {
  return [`/dc/1/getAutomatedMessages`] as const;
};

export const getGetDc1GetAutomatedMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDc1GetAutomatedMessagesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>
  > = ({ signal }) => getDc1GetAutomatedMessages(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1GetAutomatedMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>
>;
export type GetDc1GetAutomatedMessagesQueryError = unknown;

export function useGetDc1GetAutomatedMessages<
  TData = Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
          TError,
          Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1GetAutomatedMessages<
  TData = Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
          TError,
          Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1GetAutomatedMessages<
  TData = Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Automated Messages
 */

export function useGetDc1GetAutomatedMessages<
  TData = Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetAutomatedMessages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1GetAutomatedMessagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get DRS Suggestions
 */
export const postDrsQuestions = (
  drsRequestBody: DrsRequestBody,
  params: PostDrsQuestionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DRSResponseBodyNew>(
    {
      url: `/drs/questions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: drsRequestBody,
      params,
      signal,
    },
    options,
  );
};

export const getPostDrsQuestionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDrsQuestions>>,
    TError,
    { data: DrsRequestBody; params: PostDrsQuestionsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDrsQuestions>>,
  TError,
  { data: DrsRequestBody; params: PostDrsQuestionsParams },
  TContext
> => {
  const mutationKey = ["postDrsQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDrsQuestions>>,
    { data: DrsRequestBody; params: PostDrsQuestionsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postDrsQuestions(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDrsQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDrsQuestions>>
>;
export type PostDrsQuestionsMutationBody = DrsRequestBody;
export type PostDrsQuestionsMutationError = unknown;

/**
 * @summary Get DRS Suggestions
 */
export const usePostDrsQuestions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDrsQuestions>>,
      TError,
      { data: DrsRequestBody; params: PostDrsQuestionsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDrsQuestions>>,
  TError,
  { data: DrsRequestBody; params: PostDrsQuestionsParams },
  TContext
> => {
  const mutationOptions = getPostDrsQuestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get DRS RAG Suggestions
 */
export const postQuery = (
  dRSRagRequestBody: DRSRagRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<RAGResponseBody>(
    {
      url: `/query/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dRSRagRequestBody,
      signal,
    },
    options,
  );
};

export const getPostQueryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postQuery>>,
    TError,
    { data: DRSRagRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postQuery>>,
  TError,
  { data: DRSRagRequestBody },
  TContext
> => {
  const mutationKey = ["postQuery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postQuery>>,
    { data: DRSRagRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postQuery(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostQueryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postQuery>>
>;
export type PostQueryMutationBody = DRSRagRequestBody;
export type PostQueryMutationError = unknown;

/**
 * @summary Get DRS RAG Suggestions
 */
export const usePostQuery = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postQuery>>,
      TError,
      { data: DRSRagRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postQuery>>,
  TError,
  { data: DRSRagRequestBody },
  TContext
> => {
  const mutationOptions = getPostQueryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Answer From QB ID
 */
export const postQuestionsAll = (
  doubtsNewQbRequestModel: DoubtsNewQbRequestModel,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DoubtsQbResponseModel>(
    {
      url: `/questions/all`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: doubtsNewQbRequestModel,
      signal,
    },
    options,
  );
};

export const getPostQuestionsAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postQuestionsAll>>,
    TError,
    { data: DoubtsNewQbRequestModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postQuestionsAll>>,
  TError,
  { data: DoubtsNewQbRequestModel },
  TContext
> => {
  const mutationKey = ["postQuestionsAll"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postQuestionsAll>>,
    { data: DoubtsNewQbRequestModel }
  > = (props) => {
    const { data } = props ?? {};

    return postQuestionsAll(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostQuestionsAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postQuestionsAll>>
>;
export type PostQuestionsAllMutationBody = DoubtsNewQbRequestModel;
export type PostQuestionsAllMutationError = unknown;

/**
 * @summary Get Answer From QB ID
 */
export const usePostQuestionsAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postQuestionsAll>>,
      TError,
      { data: DoubtsNewQbRequestModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postQuestionsAll>>,
  TError,
  { data: DoubtsNewQbRequestModel },
  TContext
> => {
  const mutationOptions = getPostQuestionsAllMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Connect to Tutor (v2)
 */
export const putDc1V2ConnectToTutorDoubtId = (
  doubtId: number,
  connectotutorRequest: ConnectotutorRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ConnecttotutorResponse>(
    {
      url: `/dc/1/v2/connectToTutor/${doubtId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: connectotutorRequest,
    },
    options,
  );
};

export const getPutDc1V2ConnectToTutorDoubtIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>,
    TError,
    { doubtId: number; data: ConnectotutorRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>,
  TError,
  { doubtId: number; data: ConnectotutorRequest },
  TContext
> => {
  const mutationKey = ["putDc1V2ConnectToTutorDoubtId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>,
    { doubtId: number; data: ConnectotutorRequest }
  > = (props) => {
    const { doubtId, data } = props ?? {};

    return putDc1V2ConnectToTutorDoubtId(doubtId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDc1V2ConnectToTutorDoubtIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>
>;
export type PutDc1V2ConnectToTutorDoubtIdMutationBody = ConnectotutorRequest;
export type PutDc1V2ConnectToTutorDoubtIdMutationError = unknown;

/**
 * @summary Connect to Tutor (v2)
 */
export const usePutDc1V2ConnectToTutorDoubtId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>,
      TError,
      { doubtId: number; data: ConnectotutorRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDc1V2ConnectToTutorDoubtId>>,
  TError,
  { doubtId: number; data: ConnectotutorRequest },
  TContext
> => {
  const mutationOptions =
    getPutDc1V2ConnectToTutorDoubtIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Autosolve a doubt (v2)
 */
export const putDc1V2AutosolveDoubtId = (
  doubtId: number,
  autosolveRequest: AutosolveRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<AutosolveResponse>(
    {
      url: `/dc/1/v2/autosolve/${doubtId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: autosolveRequest,
    },
    options,
  );
};

export const getPutDc1V2AutosolveDoubtIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>,
    TError,
    { doubtId: number; data: AutosolveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>,
  TError,
  { doubtId: number; data: AutosolveRequest },
  TContext
> => {
  const mutationKey = ["putDc1V2AutosolveDoubtId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>,
    { doubtId: number; data: AutosolveRequest }
  > = (props) => {
    const { doubtId, data } = props ?? {};

    return putDc1V2AutosolveDoubtId(doubtId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutDc1V2AutosolveDoubtIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>
>;
export type PutDc1V2AutosolveDoubtIdMutationBody = AutosolveRequest;
export type PutDc1V2AutosolveDoubtIdMutationError = unknown;

/**
 * @summary Autosolve a doubt (v2)
 */
export const usePutDc1V2AutosolveDoubtId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>,
      TError,
      { doubtId: number; data: AutosolveRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putDc1V2AutosolveDoubtId>>,
  TError,
  { doubtId: number; data: AutosolveRequest },
  TContext
> => {
  const mutationOptions = getPutDc1V2AutosolveDoubtIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new doubt with either text or image. This path is overloaded.
 * @summary Create a doubt (v2)
 */
export const postDc1V2CreateDoubt = (
  postDc1V2CreateDoubtBody: PostDc1V2CreateDoubtBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CreateDoubtRespone>(
    {
      url: `/dc/1/v2/createDoubt`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postDc1V2CreateDoubtBody,
      signal,
    },
    options,
  );
};

export const getPostDc1V2CreateDoubtMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1V2CreateDoubt>>,
    TError,
    { data: PostDc1V2CreateDoubtBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1V2CreateDoubt>>,
  TError,
  { data: PostDc1V2CreateDoubtBody },
  TContext
> => {
  const mutationKey = ["postDc1V2CreateDoubt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1V2CreateDoubt>>,
    { data: PostDc1V2CreateDoubtBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1V2CreateDoubt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1V2CreateDoubtMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1V2CreateDoubt>>
>;
export type PostDc1V2CreateDoubtMutationBody = PostDc1V2CreateDoubtBody;
export type PostDc1V2CreateDoubtMutationError = unknown;

/**
 * @summary Create a doubt (v2)
 */
export const usePostDc1V2CreateDoubt = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1V2CreateDoubt>>,
      TError,
      { data: PostDc1V2CreateDoubtBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1V2CreateDoubt>>,
  TError,
  { data: PostDc1V2CreateDoubtBody },
  TContext
> => {
  const mutationOptions = getPostDc1V2CreateDoubtMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit DRE Feedback
 */
export const postDc1DreFeedback = (
  dreFeedbackRequest: DreFeedbackRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DreFeedbackReponse>(
    {
      url: `/dc/1/dreFeedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dreFeedbackRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1DreFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1DreFeedback>>,
    TError,
    { data: DreFeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1DreFeedback>>,
  TError,
  { data: DreFeedbackRequest },
  TContext
> => {
  const mutationKey = ["postDc1DreFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1DreFeedback>>,
    { data: DreFeedbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1DreFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1DreFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1DreFeedback>>
>;
export type PostDc1DreFeedbackMutationBody = DreFeedbackRequest;
export type PostDc1DreFeedbackMutationError = unknown;

/**
 * @summary Submit DRE Feedback
 */
export const usePostDc1DreFeedback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1DreFeedback>>,
      TError,
      { data: DreFeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1DreFeedback>>,
  TError,
  { data: DreFeedbackRequest },
  TContext
> => {
  const mutationOptions = getPostDc1DreFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Redeemable Coins
 */
export const getApiRedeemGetRedeemcoins = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetRedeemcoinsResponse>(
    { url: `/api/redeem/getRedeemcoins`, method: "GET", signal },
    options,
  );
};

export const getGetApiRedeemGetRedeemcoinsQueryKey = () => {
  return [`/api/redeem/getRedeemcoins`] as const;
};

export const getGetApiRedeemGetRedeemcoinsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiRedeemGetRedeemcoinsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>
  > = ({ signal }) => getApiRedeemGetRedeemcoins(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRedeemGetRedeemcoinsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>
>;
export type GetApiRedeemGetRedeemcoinsQueryError = unknown;

export function useGetApiRedeemGetRedeemcoins<
  TData = Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
          TError,
          Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiRedeemGetRedeemcoins<
  TData = Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
          TError,
          Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiRedeemGetRedeemcoins<
  TData = Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Redeemable Coins
 */

export function useGetApiRedeemGetRedeemcoins<
  TData = Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiRedeemGetRedeemcoins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiRedeemGetRedeemcoinsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Total Coins Earned by User
 */
export const getApiCoinsGetTotalCoinsEarnedByUserIdUserid = (
  userid: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetTotalCoinsEarnedByUserIdResponse>(
    {
      url: `/api/coins/getTotalCoinsEarnedByUserId/${userid}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryKey = (
  userid?: number,
) => {
  return [`/api/coins/getTotalCoinsEarnedByUserId/${userid}`] as const;
};

export const getGetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
  >,
  TError = unknown,
>(
  userid: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryKey(userid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>>
  > = ({ signal }) =>
    getApiCoinsGetTotalCoinsEarnedByUserIdUserid(
      userid,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!userid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>>
  >;
export type GetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryError = unknown;

export function useGetApiCoinsGetTotalCoinsEarnedByUserIdUserid<
  TData = Awaited<
    ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
  >,
  TError = unknown,
>(
  userid: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCoinsGetTotalCoinsEarnedByUserIdUserid<
  TData = Awaited<
    ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
  >,
  TError = unknown,
>(
  userid: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCoinsGetTotalCoinsEarnedByUserIdUserid<
  TData = Awaited<
    ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
  >,
  TError = unknown,
>(
  userid: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Total Coins Earned by User
 */

export function useGetApiCoinsGetTotalCoinsEarnedByUserIdUserid<
  TData = Awaited<
    ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
  >,
  TError = unknown,
>(
  userid: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCoinsGetTotalCoinsEarnedByUserIdUserid>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCoinsGetTotalCoinsEarnedByUserIdUseridQueryOptions(
      userid,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save Redeem Summary
 */
export const postApiRedeemSaveRedeemSummary = (
  saveRedeemSummaryRequest: SaveRedeemSummaryRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SaveRedeemSummaryResponse>(
    {
      url: `/api/redeem/saveRedeemSummary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveRedeemSummaryRequest,
      signal,
    },
    options,
  );
};

export const getPostApiRedeemSaveRedeemSummaryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>,
    TError,
    { data: SaveRedeemSummaryRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>,
  TError,
  { data: SaveRedeemSummaryRequest },
  TContext
> => {
  const mutationKey = ["postApiRedeemSaveRedeemSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>,
    { data: SaveRedeemSummaryRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiRedeemSaveRedeemSummary(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRedeemSaveRedeemSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>
>;
export type PostApiRedeemSaveRedeemSummaryMutationBody =
  SaveRedeemSummaryRequest;
export type PostApiRedeemSaveRedeemSummaryMutationError = unknown;

/**
 * @summary Save Redeem Summary
 */
export const usePostApiRedeemSaveRedeemSummary = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>,
      TError,
      { data: SaveRedeemSummaryRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRedeemSaveRedeemSummary>>,
  TError,
  { data: SaveRedeemSummaryRequest },
  TContext
> => {
  const mutationOptions =
    getPostApiRedeemSaveRedeemSummaryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubts Coin Redemption
 */
export const postDc1GetDoubtsCoinRedemption = (
  params: PostDc1GetDoubtsCoinRedemptionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetDoubtsCoinRedemptionResponse>(
    { url: `/dc/1/getDoubtsCoinRedemption`, method: "POST", params, signal },
    options,
  );
};

export const getPostDc1GetDoubtsCoinRedemptionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>,
    TError,
    { params: PostDc1GetDoubtsCoinRedemptionParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>,
  TError,
  { params: PostDc1GetDoubtsCoinRedemptionParams },
  TContext
> => {
  const mutationKey = ["postDc1GetDoubtsCoinRedemption"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>,
    { params: PostDc1GetDoubtsCoinRedemptionParams }
  > = (props) => {
    const { params } = props ?? {};

    return postDc1GetDoubtsCoinRedemption(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1GetDoubtsCoinRedemptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>
>;

export type PostDc1GetDoubtsCoinRedemptionMutationError = unknown;

/**
 * @summary Get Doubts Coin Redemption
 */
export const usePostDc1GetDoubtsCoinRedemption = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>,
      TError,
      { params: PostDc1GetDoubtsCoinRedemptionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1GetDoubtsCoinRedemption>>,
  TError,
  { params: PostDc1GetDoubtsCoinRedemptionParams },
  TContext
> => {
  const mutationOptions =
    getPostDc1GetDoubtsCoinRedemptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Feedback Prompts
 */
export const getFbFeedbackPrompts = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<FeedBackPromptResponse>(
    { url: `/fb/feedback/prompts`, method: "GET", signal },
    options,
  );
};

export const getGetFbFeedbackPromptsQueryKey = () => {
  return [`/fb/feedback/prompts`] as const;
};

export const getGetFbFeedbackPromptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFbFeedbackPromptsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFbFeedbackPrompts>>
  > = ({ signal }) => getFbFeedbackPrompts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFbFeedbackPromptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFbFeedbackPrompts>>
>;
export type GetFbFeedbackPromptsQueryError = unknown;

export function useGetFbFeedbackPrompts<
  TData = Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
          TError,
          Awaited<ReturnType<typeof getFbFeedbackPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFbFeedbackPrompts<
  TData = Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
          TError,
          Awaited<ReturnType<typeof getFbFeedbackPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFbFeedbackPrompts<
  TData = Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Feedback Prompts
 */

export function useGetFbFeedbackPrompts<
  TData = Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbFeedbackPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFbFeedbackPromptsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Store Feedback from Prompts
 */
export const postFbFeedbackStorefeedback = (
  storeFeedbackRequest: StoreFeedbackRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StoreFeedBackResponse>(
    {
      url: `/fb/feedback/storefeedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: storeFeedbackRequest,
      signal,
    },
    options,
  );
};

export const getPostFbFeedbackStorefeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>,
    TError,
    { data: StoreFeedbackRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>,
  TError,
  { data: StoreFeedbackRequest },
  TContext
> => {
  const mutationKey = ["postFbFeedbackStorefeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>,
    { data: StoreFeedbackRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postFbFeedbackStorefeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostFbFeedbackStorefeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>
>;
export type PostFbFeedbackStorefeedbackMutationBody = StoreFeedbackRequest;
export type PostFbFeedbackStorefeedbackMutationError = unknown;

/**
 * @summary Store Feedback from Prompts
 */
export const usePostFbFeedbackStorefeedback = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>,
      TError,
      { data: StoreFeedbackRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postFbFeedbackStorefeedback>>,
  TError,
  { data: StoreFeedbackRequest },
  TContext
> => {
  const mutationOptions =
    getPostFbFeedbackStorefeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubts to be Deducted
 */
export const getFbDoubtstoBeDeducted = (
  params: GetFbDoubtstoBeDeductedParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DoubtstoBeDeductedResponse>(
    { url: `/fb/doubtstoBeDeducted`, method: "GET", params, signal },
    options,
  );
};

export const getGetFbDoubtstoBeDeductedQueryKey = (
  params?: GetFbDoubtstoBeDeductedParams,
) => {
  return [`/fb/doubtstoBeDeducted`, ...(params ? [params] : [])] as const;
};

export const getGetFbDoubtstoBeDeductedQueryOptions = <
  TData = Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
  TError = unknown,
>(
  params: GetFbDoubtstoBeDeductedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFbDoubtstoBeDeductedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>
  > = ({ signal }) => getFbDoubtstoBeDeducted(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFbDoubtstoBeDeductedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>
>;
export type GetFbDoubtstoBeDeductedQueryError = unknown;

export function useGetFbDoubtstoBeDeducted<
  TData = Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
  TError = unknown,
>(
  params: GetFbDoubtstoBeDeductedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
          TError,
          Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFbDoubtstoBeDeducted<
  TData = Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
  TError = unknown,
>(
  params: GetFbDoubtstoBeDeductedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
          TError,
          Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFbDoubtstoBeDeducted<
  TData = Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
  TError = unknown,
>(
  params: GetFbDoubtstoBeDeductedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Doubts to be Deducted
 */

export function useGetFbDoubtstoBeDeducted<
  TData = Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
  TError = unknown,
>(
  params: GetFbDoubtstoBeDeductedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFbDoubtstoBeDeducted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFbDoubtstoBeDeductedQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generate Question Solution (RAG v3)
 */
export const postDc1GenerateQuestionSolution = (
  rAGNewRequest: RAGNewRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<RAGVResponse>(
    {
      url: `/dc/1/generateQuestionSolution`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rAGNewRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1GenerateQuestionSolutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>,
    TError,
    { data: RAGNewRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>,
  TError,
  { data: RAGNewRequest },
  TContext
> => {
  const mutationKey = ["postDc1GenerateQuestionSolution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>,
    { data: RAGNewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1GenerateQuestionSolution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1GenerateQuestionSolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>
>;
export type PostDc1GenerateQuestionSolutionMutationBody = RAGNewRequest;
export type PostDc1GenerateQuestionSolutionMutationError = unknown;

/**
 * @summary Generate Question Solution (RAG v3)
 */
export const usePostDc1GenerateQuestionSolution = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>,
      TError,
      { data: RAGNewRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1GenerateQuestionSolution>>,
  TError,
  { data: RAGNewRequest },
  TContext
> => {
  const mutationOptions =
    getPostDc1GenerateQuestionSolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Generated Solution (RAG v3)
 */
export const getDc1GetGeneratedSolution = (
  params: GetDc1GetGeneratedSolutionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetRagvSolutionResponse>(
    { url: `/dc/1/getGeneratedSolution`, method: "GET", params, signal },
    options,
  );
};

export const getGetDc1GetGeneratedSolutionQueryKey = (
  params?: GetDc1GetGeneratedSolutionParams,
) => {
  return [`/dc/1/getGeneratedSolution`, ...(params ? [params] : [])] as const;
};

export const getGetDc1GetGeneratedSolutionQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
  TError = unknown,
>(
  params: GetDc1GetGeneratedSolutionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDc1GetGeneratedSolutionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>
  > = ({ signal }) =>
    getDc1GetGeneratedSolution(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1GetGeneratedSolutionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>
>;
export type GetDc1GetGeneratedSolutionQueryError = unknown;

export function useGetDc1GetGeneratedSolution<
  TData = Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
  TError = unknown,
>(
  params: GetDc1GetGeneratedSolutionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
          TError,
          Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1GetGeneratedSolution<
  TData = Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
  TError = unknown,
>(
  params: GetDc1GetGeneratedSolutionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
          TError,
          Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1GetGeneratedSolution<
  TData = Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
  TError = unknown,
>(
  params: GetDc1GetGeneratedSolutionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Generated Solution (RAG v3)
 */

export function useGetDc1GetGeneratedSolution<
  TData = Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
  TError = unknown,
>(
  params: GetDc1GetGeneratedSolutionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1GetGeneratedSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1GetGeneratedSolutionQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
